import { markdownToDoc } from '@/lib/markdown';

export const AI_CHAT_SKILL_ICON = 'lucide-zap';

export const AI_CHAT_SKILL_SUGGESTION_LIMIT = 4;

const BUILTIN_SKILLS = [
  { key: 'cycleHealthCheck', icon: 'pulse' },
  { key: 'weeklyCheckin', icon: 'edit-square' },
  { key: 'teamStatus', icon: 'team' },
  { key: 'goalQuality', icon: 'check-circle' },
  { key: 'draftOkrs', icon: 'goals' },
  { key: 'staleGoals', icon: 'clock-circle' },
];

export const builtinSkills = (t) => BUILTIN_SKILLS.map(({ key, icon }) => ({
  id: `builtin.${key}`,
  icon,
  title: t(`aiChat.skills.builtin.${key}.title`),
  body: markdownToDoc(t(`aiChat.skills.builtin.${key}.prompt`)),
  builtin: true,
}));

// a skill that is still on its way to the server has no createdAt yet, and it is the newest
const createdAt = (skill) => skill.createdAt ?? new Date().toISOString();

export const ownSkills = (skills) => [...skills]
  .sort((a, b) => createdAt(b).localeCompare(createdAt(a)))
  .map((skill) => ({
    id: `${skill.uid}`,
    uid: skill.uid,
    icon: AI_CHAT_SKILL_ICON,
    title: skill.title,
    body: skill.body,
    builtin: false,
  }));

export const suggestedSkills = ({ own, builtins }) => [...own, ...builtins].slice(0, AI_CHAT_SKILL_SUGGESTION_LIMIT);
